export const auction_list_table_header = [
    { order: 1, key:"action" ,name: "Action", visibility: true  },
    { order: 2, key:"name" ,name: "Name", visibility: true },
    { order: 3, key:"id" ,name: "Id", visibility: false },
    { order: 4, key:"auction_group" ,name: "Auction Group", visibility: true },
    { order: 5, key:"status" ,name: "Status", visibility: true },
    { order: 6, key:"start_date" ,name: "Start Date", visibility: true  },
    { order: 7, key:"end_date" ,name: "End Date", visibility: true  },
    { order: 8, key:"created_date" ,name: "Created Date", visibility: true  },
    { order: 9, key:"updated_date" ,name: "Updated Date", visibility: false  },
]


export const data = [{
    name: "hell",
    auction_group:"hellfsdfsdf hellfsdfsdf hellfsdfsdfhellfsdfsdf hellfsdfsdf hellfsdfsdf hellfsdfsdf hellfsdfsdf hellfsdfsdf",
    status:"hell",
    start_date:"2024-01-01",
    end_date:"2024-01-01",
    created_at:-"2024-01-01",
},{
    name: "hell",
    auction_group:"hell",
    status:"hell",
    start_date:"2024-01-01",
    end_date:"2024-01-01",
    created_at:-"2024-01-01",
},{
    name: "hell",
    auction_group:"hell",
    status:"hell",
    start_date:"2024-01-01",
    end_date:"2024-01-01",
    created_at:-"2024-01-01",
}]